import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/Advisor.webp";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";
import EnquiryNow from "../common/EnquiryNow";

const Contactus = () => {
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Add actual submission logic here
    alert("Form submitted!");
  };

  return (
    <>
      <title>
        Contact ISBM University — Admissions Enquiry & Campus Details
      </title>
      <meta
        name="description"
        content="Get in touch with ISBM University for admissions, programmes and other enquiries. Find contact and campus details for Raipur and Gariyaband, Chhattisgarh."
      />
      <Topnav />

      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1> Contact Us</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Contact Us
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <div className="About_us11 py-5 container-xxl">
        <Row className="m-0">
          <Col md={4}>
            <div className="ups-card p-4 border contactDiv mb-3">
              <h2>Contact Details:</h2>
              <p>
                <a
                  href="https://api.whatsapp.com/send/?phone=%2B919373199999&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-whatsapp me-2"></i>
                </a>
                <i className="fa fa-phone me-2"></i>
                <a href="tel:+919373199999">+91-9373199999</a>
              </p>
              <p>
                <a
                  href="https://api.whatsapp.com/send/?phone=%2B919109333333&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-whatsapp me-2"></i>
                </a>
                <i className="fa fa-phone me-2"></i>
                <a href="tel:+919109333333">+91-9109333333</a>
              </p>
              <p>
                <a
                  href="https://api.whatsapp.com/send/?phone=%2B919109244444&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-whatsapp me-2"></i>
                </a>
                <i className="fa fa-phone me-2"></i>
                <a href="tel:+919109244444">+91-9109244444</a>
              </p>
              <p>
                <i className="fa fa-envelope me-2"></i>
                <a href="mailto:info@isbmuniversity.edu.in">
                  info@isbmuniversity.edu.in
                </a>
              </p>
            </div>

            <div className="ups-card p-4 border contactDiv mb-3">
              <h2>Address:</h2>
              <div className="p-4 border shadow rounded-4 mb-3">
                <h4>ISBM University Gariyaband Campus</h4>
                <p>
                  Nawapara (Kosmi), Block & Tehsil- Chhura, Gariyaband,
                  Chhattisgarh- 493996
                </p>
              </div>

              <div className="p-4 border shadow rounded-4">
                <h4>ISBM University Raipur Campus</h4>
                <p>
                  ISBM University, Ring Road No. 1, Near Sarona Bridge,
                  Tatibandh, Raipur, Chhattisgarh-492099
                </p>
              </div>
            </div>
          </Col>

          <Col md={8}>
            <div className="wm-student-dashboard-settings p-4 shadow rounded">
              <h2 className="modern-title section-title text-blue text-center">
                Talk To Us Today
              </h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter Full Name"
                    className="formcontrol"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter Email Address"
                    className="formcontrol"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder="Enter Mobile Number"
                    className="formcontrol"
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Comment</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="comment"
                    rows={3}
                    placeholder="Enter Comment"
                    className="formcontrol"
                  />
                </Form.Group>
                <Button type="submit" className="custom-submit-btn shadow ms-2">
                  Submit
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </div>

      <Footer />
    </>
  );
};

export default Contactus;
